import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import {
    adminsReducer,
    alertReducer,
    authReducer,
    eventsReducer,
    loadingReducer,
    offlineReducer,
    photographersReducer,
    sendingReducer,
    sidebarActiveTabReducer,
    themeReducer,
} from "@/redux/reducers";

export const initialStateRootReducer = {
    key: "root",
    storage,
    whitelist: [],
};

export const rootReducer = combineReducers({
    adminsReducer,
    alertReducer,
    authReducer,
    eventsReducer,
    loadingReducer,
    offlineReducer,
    photographersReducer,
    sendingReducer,
    sidebarActiveTabReducer,
    themeReducer,
});
